
const digest = 'ce803ffd68b3a19c1a52d822f58c0cbf30bd7c630a3e353c6af08e900db701a2';
const classes = {"firstCell":"_firstCell_vsfm5_1"};
const css = `._firstCell_vsfm5_1 {
  font-weight: 500 !important;
  background-color: #f5f7fa !important;
  border-color: #d8dee7 !important;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  